import React from "react";
import { Box, Typography, Chip, Stack, Card, CardContent } from "@mui/material";

const StaffLocationMap = ({ staffLocations = [], isLoading = false }) => {
    if (isLoading) {
        return (
            <Box
                sx={{
                    height: 320,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                    borderRadius: 2,
                }}
            >
                <Typography variant="body2" sx={{ color: "#666" }}>
                    Loading staff locations...
                </Typography>
            </Box>
        );
    }

    if (!staffLocations || staffLocations.length === 0) {
        return (
            <Box
                sx={{
                    height: 320,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                    borderRadius: 2,
                }}
            >
                <Typography variant="body2" sx={{ color: "#666" }}>
                    No staff locations available
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ height: 320, borderRadius: 2, overflow: "hidden" }}>
            <Box
                sx={{
                    height: "100%",
                    background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                    borderRadius: 2,
                    p: 2,
                    overflow: "auto",
                }}
            >
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    Staff Locations ({staffLocations.length})
                </Typography>

                <Stack spacing={2}>
                    {staffLocations.map((staff) => (
                        <Card key={staff.id} sx={{ p: 1 }}>
                            <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
                                <Stack direction="row" spacing={2} alignItems="center">
                                    <Box
                                        sx={{
                                            width: 40,
                                            height: 40,
                                            borderRadius: "50%",
                                            backgroundColor: staff.status === "active" ? "#4CAF50" : "#FF9800",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "white",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                        }}
                                    >
                                        👤
                                    </Box>

                                    <Box sx={{ flex: 1 }}>
                                        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                            {staff.name}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: "#666" }}>
                                            📱 {staff.mobile}
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: "#666", display: "block" }}>
                                            🏢 {staff.region}
                                        </Typography>
                                    </Box>

                                    <Box sx={{ textAlign: "right" }}>
                                        <Chip
                                            label={staff.status}
                                            size="small"
                                            sx={{
                                                backgroundColor: staff.status === "active" ? "#e8f5e8" : "#ffebee",
                                                color: staff.status === "active" ? "#2e7d32" : "#d32f2f",
                                                fontWeight: 600,
                                                fontSize: "0.7rem",
                                                mb: 1,
                                            }}
                                        />
                                        <Typography variant="caption" sx={{ color: "#666", display: "block" }}>
                                            Sales: ₹{staff.sales?.toLocaleString() || "0"}
                                        </Typography>
                                    </Box>
                                </Stack>
                            </CardContent>
                        </Card>
                    ))}
                </Stack>
            </Box>
        </Box>
    );
};

export default StaffLocationMap;
